var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"display":"block"},attrs:{"disabled":_vm.disabled,"options":_vm.makeDisableCategories ? _vm.getCategoriesForSelector : _vm.getCategoriesForAdditionalSelector,"placeholder":_vm.placeholder ? _vm.placeholder : 'Select',"props":{ checkStrictly: true },"value":_vm.value},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }